const pct = (m, a) => (a ? `${Math.round((m / a) * 100)}%` : "");
const shot = (m, a) => `${m ?? 0}/${a ?? 0}`;
const COLS = ["#", "PLAYER", "MIN", "PTS", "2P", "3P", "FT", "OR", "DR", "TR", "AST", "STL", "TO", "BLK", "BLKA", "PF", "FD", "+/-", "PIR"];

function Cells({ l }) {
  return (
    <>
      <td>{l.min || "—"}</td><td className="eu-box-pts">{l.pts ?? 0}</td>
      <td title={pct(l.fg2m, l.fg2a)}>{shot(l.fg2m, l.fg2a)}</td><td title={pct(l.fg3m, l.fg3a)}>{shot(l.fg3m, l.fg3a)}</td><td title={pct(l.ftm, l.fta)}>{shot(l.ftm, l.fta)}</td>
      <td>{l.oreb ?? 0}</td><td>{l.dreb ?? 0}</td><td>{l.reb ?? 0}</td><td>{l.ast ?? 0}</td><td>{l.stl ?? 0}</td><td>{l.tov ?? 0}</td>
      <td>{l.blk ?? 0}</td><td>{l.blka ?? 0}</td><td>{l.pf ?? 0}</td><td>{l.fd ?? 0}</td>
      <td className={l.pm > 0 ? "ncs-positive" : l.pm < 0 ? "ncs-negative" : ""}>{l.pm == null ? "" : l.pm > 0 ? `+${l.pm}` : l.pm}</td>
      <td className="eu-pir">{l.pir ?? 0}</td>
    </>
  );
}

export function BoxTable({ club, team, side, live }) {
  const played = team.players.filter((p) => !p.dnp);
  const dnp = team.players.filter((p) => p.dnp);
  return (
    <section className="ncs-panel" data-testid={`europe-box-${side}`}>
      <h2>{club.crest && <img src={club.crest} alt="" className="eu-box-crest" />}{club.name.toUpperCase()}{team.coach && <small className="eu-box-coach">Coach {team.coach}</small>}</h2>
      <div className="ncs-scroll">
        <table className="eu-box">
          <thead><tr>{COLS.map((c) => <th key={c} className={c === "PLAYER" ? "ncs-team-col" : ""}>{c}</th>)}</tr></thead>
          <tbody>
            {played.map((p) => (
              <tr key={p.code} className={live && p.on_court ? "eu-on-court" : ""} data-testid={`europe-box-player-${p.code}`}>
                <td className="ncs-seed">{p.jersey}</td>
                <td className="ncs-team-col"><span className="eu-player">{p.photo ? <img src={p.photo} alt="" loading="lazy" /> : <i />}{p.name}{p.starter && <em className="eu-starter" title="Starter">S</em>}</span></td>
                <Cells l={p} />
              </tr>
            ))}
            {team.team_reb && (team.team_reb.reb > 0 || team.team_reb.pir) ? (
              <tr className="eu-box-team"><td /><td className="ncs-team-col">Team</td><Cells l={{ ...team.team_reb, min: "", pm: null }} /></tr>
            ) : null}
            <tr className="eu-box-total" data-testid={`europe-box-totals-${side}`}><td /><td className="ncs-team-col">TOTALS</td><Cells l={{ ...team.totals, pm: null }} /></tr>
          </tbody>
        </table>
      </div>
      {dnp.length > 0 && <p className="eu-dnp">Did not play: {dnp.map((p) => p.name).join(", ")}</p>}
    </section>
  );
}
